import { asyncMultiSelect, asyncSelect } from "../fields/asyncSelect";
import { checkbox } from "../fields/checkbox";
import { checkboxGroup } from "../fields/checkboxGroup";
import { date } from "../fields/date";
import { datetime } from "../fields/datetime";
import { dynamic } from "../fields/dynamic";
import { file } from "../fields/file";
import { input } from "../fields/input";
import { list } from "../fields/list";
import { radioGroup } from "../fields/radioGroup";
import { multiSelect, select } from "../fields/select";
import { set } from "../fields/set";
import { tags } from "../fields/tags";
import { template } from "../fields/template";
import { textarea } from "../fields/textarea";

export const defaultFieldTypes = {
	asyncMultiSelect,
	asyncSelect,
	checkbox,
	checkboxGroup,
	date,
	datetime,
	dynamic,
	file,
	input,
	list,
	radioGroup,
	multiSelect,
	select,
	set,
	tags,
	template,
	textarea,
};
